const listTableFields = [
  {
    label: 'Nomor Kontrak',
    key: 'number',
    isSortable: true,
    isRedirectable: true,
    hasOpenNewTab: true,
  },
  {
    label: 'Status',
    key: 'status.name',
  },
  {
    label: 'Nama Pelanggan',
    key: 'customer.name',
  },
  {
    label: 'Asal Kontrak',
    key: 'state.name',
  },
  {
    label: 'Diperbarui dari',
    key: 'reference.number',
    formatter: (value) => value ? value : '-',
  },
  {
    label: 'Jenis Kontrak',
    key: 'contract_type',
  },
  {
    label: 'Kota',
    key: 'city',
  },
  {
    label: 'Tanggal Mulai',
    key: 'effective_date',
    isSortable: true,
  },
  {
    label: 'Tanggal Berakhir',
    key: 'expired_date',
    isSortable: true,
  },
  {
    label: 'Jumlah Kendaraan',
    key: 'total_vehicle',
    formatter: (value) => value ? value : 0,
  },
  {
    label: 'Penanggung Jawab',
    key: 'custodian.name',
  },
  {
    label: 'Pelacakan',
    key: 'public_tracking_url',      
    isLocked: true,
    tdAttr: {
      style: 'right:0px;position:sticky;border-left:1px solid #e6e7ec',
    },
    thAttr: {
      style: 'right:0px;position:sticky;z-index:1;border-left:1px solid #e6e7ec',
    },
  },
]

export default listTableFields
